class ComponentStickyAtc extends HTMLElement {
  connectedCallback() {
    this.atcBtnContainer =
      document.querySelector('.pdpForm') ||
      document.querySelector('hh-product-bundle-pdp')

    const options = {
      root: null,
      rootMargin: '0px 0px -100%',
      threshold: [0, 1],
    }

    this.observer = new IntersectionObserver(
      this.showStickyAtc.bind(this),
      options
    )
    this.observer.observe(this.atcBtnContainer)
    this.addEventListener('click', this.initAtcEvent.bind(this))
  }

  disconnectedCallback() {
    this.observer.disconnect()
    this.removeEventListener('click', this.initAtcEvent.bind(this))
  }

  initAtcEvent() {
    const customEvent = new CustomEvent('sticky:atc', {})
    document.dispatchEvent(customEvent)
  }

  showStickyAtc(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting || entry.isVisible) {
        this.classList.remove('active')
        return
      }
      if (-entry.boundingClientRect.height > entry.boundingClientRect.top) {
        this.classList.add('active')
      } else {
        this.classList.remove('active')
      }
    })
  }
}

customElements.define('pdp-sticky-atc', ComponentStickyAtc)
